import React, { Component } from 'react';
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "react-fontawesome";
import Route from "../../../components/Routes";
import "../../../assets/scss/style/_searchBoard.scss"
import { faSearch } from '@fortawesome/free-solid-svg-icons';

class SearchBoard extends Component {
    state = {
        loading: false,
        updated: false,

        industries: [],
        industry_value: null,

        specializations: [],
        specialization_value: null,

        keyword_value: '',
        query: '',
        check: false
    }
    search = () => {


        const { industry_value, specialization_value, keyword_value } = this.state;

        const query = JSON.stringify({
            industry_value: industry_value,
            specialization_value: specialization_value,
            keyword_value: keyword_value,
        });

        this.setState({
            updated: true,
            query: query,
        });
    }

    handleChangeKeyword = (event) => {
        const keyword_value = event.target.value;
        this.setState({
            keyword_value,
        });
    }
    render() {
        const { updated, industries, industry_value, specializations, specialization_value, keyword_value, query, check } = this.state;

        if (updated) {
            return <Redirect to={Route.toUrl("search", { query: query })} />
        }
        return (
            <div className="searchBoard">
                <div className="searchItems">
                    <h1>GET THE RIGTH
                    SOFTWARE FOR YOUR
                    SPECIFIC NEEDS </h1>
                    <div className="inputBlock">
                        <input onChange={e => this.handleChangeKeyword(e)} placeholder="What kind of software are you looking for?"></input>
                        <button onClick={this.search}> <img src="/search.png" /> Go</button>
                    </div>

                </div>

            </div>
        );
    }
}

export default SearchBoard;



